import React, { memo } from 'react';

function BrandRadarLegend() {
  return (
    <div className="BrandRadar-legend">
      <div className="BrandRadar-legend-item">
        <div
          className="BrandRadar-legend-dot"
          style={{ background: '#c8ff00' }}
        />
        Center
      </div>
      <div className="BrandRadar-legend-item">
        <div
          className="BrandRadar-legend-dot"
          style={{ background: 'rgba(200,255,0,.5)' }}
        />
        Level 1
      </div>
      <div className="BrandRadar-legend-item">
        <div
          className="BrandRadar-legend-dot"
          style={{ background: 'rgba(200,255,0,.18)' }}
        />
        Level 2
      </div>
    </div>
  );
}

export default memo(BrandRadarLegend);
